module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/110-guinea-316f78a879a7fae9745e0f7a410a1d4f.svg";